import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'label']
  static values = {
    checkedClass: String,
    uncheckedClass: String
  }

  connect() {
    this.checkedClasses = this.checkedClassValue.split(' ')
    this.uncheckedClasses = this.uncheckedClassValue.split(' ')
    this.update()
  }

  update() {
    this.inputTargets.forEach((input, index) => {
      if (input.checked) {
        this.labelTargets[index].classList.add(...this.checkedClasses)
        this.labelTargets[index].classList.remove(...this.uncheckedClasses)
      } else {
        this.labelTargets[index].classList.remove(...this.checkedClasses)
        this.labelTargets[index].classList.add(...this.uncheckedClasses)
      }
    })
  }
}
